import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import i18nResources from './i18n-resources';

i18n
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        lng: (__VISUELSE__ ? 'en' : 'hu'),
        fallbackLng: 'en',
        resources:i18nResources,
        initImmediate:true,
        debug: false, //process.env.NODE_ENV == 'development',
        keySeparator: false,

        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        }
    });

export default i18n;
